<template>
  <div class="settings">
    <form @submit.prevent="submitSettings">
      <div class="title">
        Настройки для доставки
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-3">
          Адрес магазина
        </div>
        <div
          class="form-group__control col-xs-9"
          v-text="storeAddress"
        />
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Горизонт доставки, дней
        </div>
        <q-input
          v-model="vDeliveryHorizont"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="title">
        Ограничение по габаритам (для каждого товара)
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Высота, см
        </div>
        <q-input
          v-model="vHeight"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Длина, см
        </div>
        <q-input
          v-model="vLength"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Ширина, см
        </div>
        <q-input
          v-model="vWidth"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="title">
        Ограничение для заказа
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Объём, м3
        </div>
        <q-input
          v-model="vVolume"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="form-group row col-gutters-xs">
        <div class="form-group__label label col-xs-9">
          Вес, кг
        </div>
        <q-input
          v-model="vWeight"
          class="form-group__control col-xs-3"
          square
          outlined
          dense
        />
      </div>
      <div class="col-xs-12 actions">
        <div class="row reverse">
          <div class="col-sm-3 col-xs-12">
            <q-btn
              type="submit"
              class="full-width"
              size="16px"
              label="Сохранить"
              unelevated
              color="primary"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/**
 * Компонент отображает вкладку с формой настроек магазина
 * @module PageShop/Component/SelectedStore/Settings
 * @requires vuex
 * @vue-computed {String} storeAddress - адрес магазина
 * @vue-computed {Object} vDeliveryHorizont - горизонт доставки
 * @vue-computed {Object} vHeight - Высота (см)
 * @vue-computed {Object} vWidth - Ширина (см)
 * @vue-computed {Object} vLength - Длина (см)
 * @vue-computed {Object} vWeight - вес (кг)
 * @vue-computed {Object} vVolume - Объём (м3)
 */
import { createNamespacedHelpers } from 'vuex'

const storeModule = createNamespacedHelpers('storeModule')
const settingsModule = createNamespacedHelpers('storeModule/settingsModule')

export default {
  name: 'Settings',
  computed: {
    ...storeModule.mapState(['currentStore']),
    ...settingsModule.mapState(['settings']),
    storeAddress() { return this.currentStore.address },
    vDeliveryHorizont: {
      get() { return this.settings.deliveryHorizont },
      set(val) { this.updateSettings({ deliveryHorizont: val }) }
    },
    vHeight: {
      get() { return this.settings.height },
      set(val) { this.updateSettings({ height: val }) }
    },
    vWidth: {
      get() { return this.settings.width },
      set(val) { this.updateSettings({ width: val }) }
    },
    vLength: {
      get() { return this.settings.length },
      set(val) { this.updateSettings({ length: val }) }
    },
    vWeight: {
      get() { return this.settings.weight },
      set(val) { this.updateSettings({ weight: val }) }
    },
    vVolume: {
      get() { return this.settings.volume },
      set(val) { this.updateSettings({ volume: val }) }
    }
  },
  methods: {
    ...settingsModule.mapMutations(['updateSettings']),
    ...settingsModule.mapActions(['submitSettings'])
  }
}
</script>

<style lang="scss" scoped>
.settings {
  padding: 20px;
  max-width: 800px;

  .title {
    margin-bottom: 20px;

    font-size: 18px;
    font-weight: 600;
  }

  .label {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
